/*!
 * storagetify v1.0.0 (https://github.com/ajiho/storagetify)
 * Copyright 2023-2024 ajiho
 * license MIT(https://github.com/ajiho/storagetify/blob/master/LICENSE)
 */

var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}

function mitt(n){return {all:n=n||new Map,on:function(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e]);},off:function(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]));},emit:function(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e);}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e);});}}}

class TagSet {
  constructor(tag, cache) {
    //标签的缓存Key
    this.tag = Array.isArray(tag) ? tag : [tag];

    //缓存句柄
    this.handler = cache;
  }
  set(key, value, expire = null) {
    this.handler.set(key, value, expire);
    this.append(key);
  }
  append(key) {
    for (const tag of this.tag) {
      //读取标签
      const tagItems = this.handler.getTagItems(tag);

      //判断标签是否在数组里,不再就直接加入
      if (!tagItems.includes(key)) {
        //加入数组
        tagItems.push(key);

        //重新设置回去
        this.handler.set(tag, tagItems);
      }
    }
  }
  clear() {
    for (const tag of this.tag) {
      const tagItems = this.handler.getTagItems(tag);

      //分别遍历删除所有的缓存
      for (const cacheKey of tagItems) {
        this.handler.delete(cacheKey);
      }
      //再删除标签
      this.handler.delete(tag);
    }
  }
}

//参数默认值
const Default = {
  type: 'local',
  //默认驱动是 localStorage
  expire: 0,
  //单位是秒
  prefix: '',
  //key的前缀
  serialize: JSON.stringify,
  //序列化
  deserialize: JSON.parse //反序列化
};
var _emitter = /*#__PURE__*/_classPrivateFieldLooseKey("emitter");
var _storage = /*#__PURE__*/_classPrivateFieldLooseKey("storage");
var _config = /*#__PURE__*/_classPrivateFieldLooseKey("config");
var _getKey = /*#__PURE__*/_classPrivateFieldLooseKey("getKey");
class Storagetify {
  constructor(config) {
    Object.defineProperty(this, _getKey, {
      value: _getKey2
    });
    Object.defineProperty(this, _emitter, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _storage, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _config, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _config)[_config] = {
      ...Default,
      ...config
    };
    _classPrivateFieldLooseBase(this, _emitter)[_emitter] = mitt();
    _classPrivateFieldLooseBase(this, _storage)[_storage] = window[`${_classPrivateFieldLooseBase(this, _config)[_config].type}Storage`];
  }
  on(event, callback) {
    _classPrivateFieldLooseBase(this, _emitter)[_emitter].on(event, callback);
  }
  set(key, value, expire = null) {
    const cacheValue = {
      value,
      expire: expire || _classPrivateFieldLooseBase(this, _config)[_config].expire !== 0 ? Date.now() + (expire || _classPrivateFieldLooseBase(this, _config)[_config].expire) * 1000 : 0
    };
    try {
      _classPrivateFieldLooseBase(this, _storage)[_storage].setItem(_classPrivateFieldLooseBase(this, _getKey)[_getKey](key), _classPrivateFieldLooseBase(this, _config)[_config].serialize(cacheValue));
      //触发事件
      _classPrivateFieldLooseBase(this, _emitter)[_emitter].emit('change');
      return true;
    } catch (error) {
      return false;
    }
  }
  has(key) {
    return _classPrivateFieldLooseBase(this, _storage)[_storage].getItem(_classPrivateFieldLooseBase(this, _getKey)[_getKey](key)) !== null;
  }
  get(key, defaultValue = null) {
    const cacheValue = _classPrivateFieldLooseBase(this, _storage)[_storage].getItem(_classPrivateFieldLooseBase(this, _getKey)[_getKey](key));
    if (cacheValue) {
      const parsedValue = _classPrivateFieldLooseBase(this, _config)[_config].deserialize(cacheValue);
      if (parsedValue.expire === 0 || parsedValue.expire >= Date.now()) {
        return parsedValue.value;
      }
      this.delete(key);
    }
    return defaultValue;
  }
  delete(key) {
    _classPrivateFieldLooseBase(this, _storage)[_storage].removeItem(_classPrivateFieldLooseBase(this, _getKey)[_getKey](key));
    _classPrivateFieldLooseBase(this, _emitter)[_emitter].emit('change');
  }
  clear() {
    _classPrivateFieldLooseBase(this, _storage)[_storage].clear();
    _classPrivateFieldLooseBase(this, _emitter)[_emitter].emit('change');
  }
  remember(key, value, expire = null) {
    const cachedValue = this.get(key);
    if (cachedValue !== null) {
      return cachedValue;
    }
    if (typeof value === 'function') {
      //允许第二个参数是一个函数
      const computedValue = value();
      this.set(key, computedValue, expire);
      return computedValue;
    }
    this.set(key, value, expire);
    return value;
  }
  inc(key, step = 1) {
    const cachedValue = this.get(key, 0);
    if (typeof cachedValue === 'number') {
      this.set(key, cachedValue + step);
    }
  }
  tag(tag) {
    return new TagSet(tag, this);
  }
  dec(key, step = 1) {
    this.inc(key, -step);
  }

  //获取并删除缓存
  pull(key) {
    let value = this.get(key);
    this.delete(key);
    return value;
  }
  push(key, value) {
    const cachedValue = this.get(key, []);
    if (Array.isArray(cachedValue)) {
      cachedValue.push(value);
      this.set(key, cachedValue);
    }
  }
  store(type) {
    return new this.constructor({
      type,
      expire: _classPrivateFieldLooseBase(this, _config)[_config].expire,
      prefix: _classPrivateFieldLooseBase(this, _config)[_config].prefix,
      serialize: _classPrivateFieldLooseBase(this, _config)[_config].serialize,
      deserialize: _classPrivateFieldLooseBase(this, _config)[_config].deserialize
    });
  }
  getTagItems(tag) {
    return this.get(tag, []);
  }
}
function _getKey2(key) {
  return _classPrivateFieldLooseBase(this, _config)[_config].prefix + key;
}

export { Storagetify as default };
//# sourceMappingURL=storagetify.esm.js.map
